import { PaymentOptionsDataType } from '../../../../../api/payment/get-payment-options';
import { PAYMENT_METHOD_KEYS } from '../../../../../constants/payment-method-keys';
import { KushkiCardType, KushkiCashType, KushkiTransferType } from '../types/kushki-types';
import { FormDataType } from '../../purchase-form/purchase-form.constants';

export enum KUSHKI_METHODS {
    KUSHKI_CARD = 'KushkiCard',
    KUSHKI_CASH = 'KushkiCash',
    KUSHKI_TRANSFER = 'KushkiTransfer'
}

export enum LATINA_DOC_TYPES {
    CC = 'CC',
    CE = 'CE',
    CI = 'CI',
    CURP = 'CURP',
    DNI = 'DNI',
    NIT = 'NIT',
    PAS = 'PAS',
    PP = 'PP',
    RFC = 'RFC',
    RUC = 'RUC',
    RUT = 'RUT',
    TI = 'TI'
}

export const KUSHKI_AVAILABLE_REGION = ['MX', 'CO', 'PE', 'CL', 'EC'];

export const WORLD_DOCUMENT_DATA = {
    CL: [LATINA_DOC_TYPES.PP, LATINA_DOC_TYPES.RUT],
    CO: [LATINA_DOC_TYPES.CC, LATINA_DOC_TYPES.PP, LATINA_DOC_TYPES.NIT, LATINA_DOC_TYPES.CE, LATINA_DOC_TYPES.TI],
    EC: [LATINA_DOC_TYPES.PAS, LATINA_DOC_TYPES.RUC, LATINA_DOC_TYPES.CI],
    MX: [LATINA_DOC_TYPES.PP, LATINA_DOC_TYPES.RFC, LATINA_DOC_TYPES.CURP],
    PE: [LATINA_DOC_TYPES.DNI, LATINA_DOC_TYPES.CE, LATINA_DOC_TYPES.PAS, LATINA_DOC_TYPES.RUC]
};

export const KUSHKI_ALLOWED_METHODS = [PAYMENT_METHOD_KEYS.KUSHKI_CARD, PAYMENT_METHOD_KEYS.KUSHKI_TRANSFER, PAYMENT_METHOD_KEYS.KUSHKI_CASH];

export enum TRANSFER_FORM_NAMES {
    BANK_ID = 'bankId',
    DOCUMENT_NUMBER = 'documentNumber',
    DOCUMENT_TYPE = 'documentType',
    USER_TYPE = 'userType'
}

export const TRANSFER_USER_DATA = [
    { label: 'Persona física', value: '0' },
    { label: 'Empresa', value: '1' }
];

export const TRANSFER_SELECT_STYLES = {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    control: (styles: any) => ({
        ...styles,
        '@media (max-width: 767px)': {
            minWidth: '45vw'
        },
        backgroundColor: '#eeeeee',
        border: '1px solid #ced4da',
        borderRadius: 5,
        color: '#262626',
        height: 50,
        maxWidth: 280,
        minWidth: 250
    }),

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    indicatorContainer: (styles: any) => ({
        ...styles,
        color: 'black'
    }),

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    indicatorSeparator: (styles: any) => ({
        ...styles,
        color: 'black'
    })
};

export const TRANSFER_SELECT_BANK_STYLES = {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    control: (styles: any) => ({
        ...styles,
        '@media (max-width: 767px)': {
            minWidth: '93vw'
        },
        backgroundColor: '#eeeeee',
        border: '1px solid #ced4da',
        borderRadius: 5,
        color: '#262626',
        height: 50,
        maxWidth: 516,
        minWidth: 516
    }),

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    indicatorContainer: (styles: any) => ({
        ...styles,
        color: 'black'
    }),

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    indicatorSeparator: (styles: any) => ({
        ...styles,
        color: 'black'
    })
};

export enum CASH_FORM_NAMES {
    DOCUMENT_NUMBER = 'documentNumber',
    DOCUMENT_TYPE = 'documentType',
    FIRST_NAME = 'firstName',
    LAST_NAME = 'lastName'
}

export const CASH_SELECT_STYLES = {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    control: (styles: any) => ({
        '@media (max-width: 767px)': {
            width: '45vw'
        },
        ...styles,
        backgroundColor: '#eeeeee',
        border: '1px solid #ced4da',
        borderRadius: 5,
        color: '#262626',
        height: 50,
        width: 230
    }),

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    indicatorContainer: (styles: any) => ({
        ...styles,
        color: 'black'
    }),

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    indicatorSeparator: (styles: any) => ({
        ...styles,
        color: 'black'
    })
};

export enum CARD_FORM_NAMES {
    CVC = 'cvc',
    FIRST_NAME = 'firstName',
    LAST_NAME = 'lastName',
    NUMBER = 'number',
    POST_DATE = 'postDate'
}

export enum CARD_TYPES {
    CREDIT = 'credit',
    DEBIT = 'debit'
}

export type KushkiDataType = KushkiCashType & KushkiTransferType & KushkiCardType;

export type KushkiResponse = { endpoint: string; error: Error };

export type KushkiPaymentRequestType = {
    paymentOptionsData: PaymentOptionsDataType;
    paymentMethod: PAYMENT_METHOD_KEYS;
    kushkiFormData: KushkiDataType;
    invoiceFormData: FormDataType;
    withInvoice: boolean;
    price: string,
    user: User,
    currency: Currency
};
